import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type { Page } from './page'

/**
 * Aliases for app pages that correspond to {@link Page prebuilt pages}
 */
export enum AppPageAlias {
  Actions = 'actions',
  Allocations = 'allocs',
  Catalog = 'catalog',
  /** @deprecated - Moved to admin center */
  DeploymentCenter = 'deploy',
  Dimension = 'dimension',
  Entity = 'entity',
  Enum = 'enum',
  Gl = 'gl',
  Graph = 'graph',
  PageBuilder = 'page-builder',
  Pages = 'pages',
  Report = 'report',
  Reports = 'reports',
  Rules = 'rules',
  Snapshot = 'snapshot',
  WidgetBuilder = 'widget-builder',
  Widgets = 'widgets',
}
// Needs to be before namespace is defined
const NAVIGATION_IDS: ReadonlySet<AppPageAlias> = new Set(
  Object.values(AppPageAlias) as AppPageAlias[],
)
export namespace AppPageAlias {
  export const ALL: readonly AppPageAlias[] = Array.from(NAVIGATION_IDS)
  export const isNavigationId = TypeChecker.Factory.oneOf(NAVIGATION_IDS)
  export const assertIsNavigationId: TypeAsserter<AppPageAlias> =
    TypeAsserter.Factory.from(isNavigationId)
}
